import styled from '@emotion/styled';
import { Icon, Text } from '@blueprint/ui';
import { css } from '@emotion/react';

const minHeight = '3rem';
const tempLargerBreakPoint = '@media only screen and (min-width: 1140px)';

export const MobileQuickSearchBarWrapper = styled.div(
    ({ theme: { colors, spacing, borderRadius } }) => css`
        width: 100%;
        min-height: ${minHeight};
        border: 1px solid ${colors['graphic-divider']};
        border-radius: ${borderRadius['300']};
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: ${spacing['8px']} ${spacing['8px']};
        top: ${spacing['8px']};
        background-color: ${colors['graphic-background']};

        ${Text} {
            align-content: left;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        ${tempLargerBreakPoint} {
            display: none;
        }
    `
);

export const Wrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin: 0 ${spacing['8px']};
        cursor: pointer;
    `
);

export const StyledLocationText = styled.span(
    ({ theme: { colors, type } }) => css`
        color: ${colors['text-title']};
        font-weight: ${type.semiBold};
    `
);

export const StyledRadiusText = styled.span(
    ({ theme: { mq } }) => css`
        display: none;

        ${mq.medium} {
            display: inline-block;
        }
    `
);

export const StyledIcon = styled(Icon)(
    ({ theme: { spacing } }) => css`
        margin-right: ${spacing['4px']};
        min-width: 20px;
    `
);

export const Divider = styled.span(
    ({ theme: { colors, spacing, borderRadius } }) => css`
        width: 0.25rem;
        height: 0.25rem;
        border-radius: ${borderRadius['600']};
        background-color: ${colors['graphic-divider']};
        margin: 0 ${spacing['8px']} ${spacing['4px']} ${spacing['8px']};
        align-self: center;
        display: inline-block;
    `
);
